import { Filter } from '@blk/awt-aladdinwealthserver';
import { AxiosResponse, CancelToken } from 'axios';
import { SearchEntity } from '../../tempModels/SearchEntity';
import { wrapAGraphRequest } from '../../utils/AGraphWrapper';
import { removeFieldIfEmptyString } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { awApiWithPkg } from './Base';

export interface GetTypeaheadWithColTagParams {
  analysisDate: string;
  benchType: string;
  disableViewAs?: boolean;
  max?: number;
  pkg: string;
  prefix?: boolean;
  quick?: boolean;
  runType: string;
  userInput: string;
}

export function getTypeaheadWithColTag(
  tag: string,
  colTag: string,
  params: GetTypeaheadWithColTagParams,
  cancelToken?: CancelToken
): Promise<AxiosResponse<string[]>> {
  const path = `api/v1/search/typeahead/${tag}/${colTag}`;
  const requestParams = isAGraphEnabled() ? removeFieldIfEmptyString(params, 'userInput') : params;
  return awApiWithPkg.get(path, { params: requestParams, cancelToken });
}

/*
 * the typeahead search supports both GET and POST
 * the difference is that we can only supply filters in the POST request
 */
export function postSearchTypeahead(
  tag: string,
  colTag: string,
  params: GetTypeaheadWithColTagParams,
  filters?: Filter[],
  cancelToken?: CancelToken
): Promise<AxiosResponse<string[]>> {
  const path = `api/v1/search/typeahead/${tag}/${colTag}`;
  const requestParams = isAGraphEnabled() ? removeFieldIfEmptyString(params, 'userInput') : params;
  return awApiWithPkg.post<string[]>(path, wrapAGraphRequest(filters, 'filters', isAGraphEnabled()), {
    params: requestParams,
    cancelToken,
  });
}

export function postTypeaheadSearchEntities(
  tag: string,
  colTag: string,
  params: GetTypeaheadWithColTagParams,
  filters: Filter[] = [],
  cancelToken?: CancelToken
) {
  const path = `api/v1/search/entities/${tag}/${colTag}`;
  const requestParams = isAGraphEnabled() ? removeFieldIfEmptyString(params, 'userInput') : params;
  return awApiWithPkg.post<SearchEntity[]>(path, wrapAGraphRequest(filters, 'filters', isAGraphEnabled()), {
    params: requestParams,
    cancelToken,
  });
}
